/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-02-05 15:22:00
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getCompanyList
   * @description 普通商户列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getCompanyList(data) {
    return request.get(`${BASE_URL}/company/list`, data)
  },
  /**
   * createCompany
   * @description 普通商户新增
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  createCompany(data) {
    return request.post(`${BASE_URL}/company/store`, data)
  },

  /**
   * createCompany
   * @description 普通商户编辑
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  updateCompany(id, data) {
    return request.put(`${BASE_URL}/company/update/${id}`, data)
  },

   /**
   * viewCompany
   * @description 普通商户详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  viewCompany(data) {
    return request.get(`${BASE_URL}/company/view/${data}`)
  },

  /**
   * deleteCompany
   * @description 普通商户删除
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
  */
  deleteCompany(data) {
    return request.Delete(`${BASE_URL}/company/delete/${data}`)
  },

  /**
   * getSmsTemplate
   * @description 获取短信模版数据
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  getSmsTemplate() {
    return request.get(`${BASE_URL}/company/get_sms_template`, null)
  },

  /**
   * saveRate
   * @description 设置税率
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  saveRate(id, data) {
    return request.put(`${BASE_URL}/company/save_rate/${id}`, data)
  },

  /**
   * subAccount
   * @description 银行账户列表
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  subAccount(data) {
    return request.get(`${BASE_URL}/company/sub_account/${data}`)
  },

  // 支付宝进件资料提交
  createAlipaySubmission(data) {
    return request.post(`${BASE_URL}/company/alipay_submission`, data)
  },

  // 支付宝进件资料详情
  alipaySubmissionInfo(data) {
    return request.post(`${BASE_URL}/company/alipay_submission_detail`, data)
  },
  
  deleteSubAccount(data) {
    return request.Delete(`${BASE_URL}/company/delete/account/${data}`)
  },

  /**
   * createAccount
   * @description 创建银行账户
   * @author YM
   * @date 2019-03-04
   * @returns
  */
 createAccount(id, data) {
   return request.put(`${BASE_URL}/company/create_account/${id}`, data)
 },

 /**
   * getCategoryList
   * @description 获取银行渠道列表
   * @author YM
   * @date 2019-03-04
   * @returns
  */
 getCategoryList() {
  return request.get(`${BASE_URL}/settlement/category_list`)
 },
  /**
   * @description 获取公司分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getCompanyCategoryList() {
    return request.get(`${BASE_URL}/company/category_list`)
  },
  
  /**
   * @description 获取开票类目列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getInvoiceCategoryList() {
    return request.post(`${BASE_URL}/invoice/category`)
  },

  /**
   * @description 普通商户/api商户状态审核
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  companyAudit(id, data) {
    return request.put(`${BASE_URL}/company/audit/${id}`, data)
  },
  /**
   * @description 获取银行编码
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  getBankCode() {
    return request.get(`${BASE_URL}/bank_code/list`, null)
  },

  /**
   * @description 完成支付宝签约
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  alipayAccount(id, data) {
    return request.put(`${BASE_URL}/company/alipay_account/${id}`, data)
  },
  // 完成安庆通道签约
  anqingAccount(id, data) {
    return request.put(`${BASE_URL}/company/aq_account/${id}`, data)
  },
  // 获取渠道列表
  getCompanyChannelList(data) {
    return request.get(`${BASE_URL}/company/channel_select`, data)
  },
  // 获取合同乙方列表
  getCompanyChannelCompanyList(data) {
    return request.get(`${BASE_URL}/company/channel_company_select`, data)
  },

//   /**
//    * saveCategory
//    * @description 保存公司
//    * @author YQ
//    * @date 2019-01-19
//    * @param {*} data
//    * @returns
//    */
//   saveCompany(data) {
//     return request.post('/company/store', data)
//   },
//   /**
//    * getCategoryInfo
//    * @description 获取公司详情
//    * @author YQ
//    * @date 2019-01-19
//    * @param {*} data
//    * @returns
//    */
// getCompanyInfo(id) {
// let data = {id:id}
// return request.post(`${BASE_URL}/company/get_info`, data)
// }
//   /**
//    * @description 分类排序
//    * @author YM
//    * @date 2019-03-07
//    * @param {*} ids
//    * @returns
//    */
//   orderCompany(ids) {
//     let data = {ids:ids}
//     return request.post('/company/order',data)
//   },

//   /**
//    * @description 获取公司分类列表
//    * @author YM
//    * @date 2019-03-04
//    * @returns
//   */
//   getCompanySubCategoryList(id) {
//     let data = {id:id}
//     return request.post('/company/sub_category_list', data)
//   },
//   /**
//    * @description 创建子账户
//    * @author YM
//    * @date 2019-03-04
//    * @returns
//   */
//   createSubAccount(company_id, company_name, channel_account,acct_type,in_bank_code,in_bank_no) {
//     let data = {
//       company_id,
//       company_name,
//       channel_account,
//       acct_type,
//       in_bank_code,
//       in_bank_no
//     }
//     return request.post('/company/create_mainaccount', data)
//   },
//   /**
//    * @description 测试服务充值
//    * @author YM
//    * @date 2019-03-04
//    * @returns
//   */
//  createRecharge(money, channel_account, company_id) {
//   let data = {
//     money,
//     channel_account,
//     company_id
//   }
//   return request.post('/company/create_recharge', data)
//  },
//  /**
//    * @description 获取银行编码
//    * @author YM
//    * @date 2019-03-04
//    * @returns
//   */
//  getBankCode() {
//   return request.post('/bank_code/list', null)
//  }
}